import {
    ArticleRounded,
    AudioFileRounded,
    FolderRounded,
    InsertPhotoRounded,
    PictureAsPdfRounded,
    VideoLibraryRounded,
} from '@mui/icons-material';
import {
    Avatar,
    Box,
    Card,
    CardContent,
    CardHeader,
    CardMedia,
    Grid,
} from '@mui/material';

const files = [
    {
        id: 1,
        name: 'File 1',
        size: '1.5MB',
        date: '2021-09-10',
        Icon: FolderRounded,
    },
    {
        id: 2,
        name: 'File 2',
        size: '2.5MB',
        date: '2021-09-11',
        Icon: FolderRounded,
    },
    {
        id: 3,
        name: 'File 3',
        size: '3.5MB',
        date: '2021-09-12',
        Icon: FolderRounded,
    },
    {
        id: 4,
        name: 'File 4',
        size: '4.5MB',
        date: '2021-09-13',
        Icon: VideoLibraryRounded,
    },
    {
        id: 5,
        name: 'File 5',
        size: '5.5MB',
        date: '2021-09-14',
        Icon: PictureAsPdfRounded,
    },
    {
        id: 6,
        name: 'File 6',
        size: '6.5MB',
        date: '2021-09-15',
        Icon: AudioFileRounded,
    },
    {
        id: 7,
        name: 'File 7',
        size: '7.5MB',
        date: '2021-09-16',
        Icon: ArticleRounded,
    },
    {
        id: 8,
        name: 'File 8',
        size: '8.5MB',
        date: '2021-09-17',
        Icon: InsertPhotoRounded,
    },
    {
        id: 9,
        name: 'File 9',
        size: '9.5MB',
        date: '2021-09-18',
        Icon: PictureAsPdfRounded,
    },
    {
        id: 10,
        name: 'File 10',
        size: '10.5MB',
        date: '2021-09-19',
        Icon: PictureAsPdfRounded,
    },
    {
        id: 11,
        name: 'File 11',
        size: '11.5MB',
        date: '2021-09-20',
        Icon: PictureAsPdfRounded,
    },
    {
        id: 12,
        name: 'File 12',
        size: '12.5MB',
        date: '2021-09-21',
        Icon: PictureAsPdfRounded,
    },
    {
        id: 13,
        name: 'File 13',
        size: '13.5MB',
        date: '2021-09-22',
        Icon: PictureAsPdfRounded,
    },
    {
        id: 14,
        name: 'File 14',
        size: '14.5MB',
        date: '2021-09-23',
        Icon: PictureAsPdfRounded,
    },
    {
        id: 15,
        name: 'File 15',
        size: '15.5MB',
        date: '2021-09-24',
        Icon: PictureAsPdfRounded,
    },
    {
        id: 16,
        name: 'File 16',
        size: '16.5MB',
        date: '2021-09-25',
        Icon: PictureAsPdfRounded,
    },
    {
        id: 17,
        name: 'File 17',
        size: '17.5MB',
        date: '2021-09-26',
        Icon: PictureAsPdfRounded,
    },
];

const FileComponent = ({ file }) => {
    const Icon = file.Icon;
    return (
        <Card variant="outlined">
            <CardMedia>
                <Avatar
                    variant="square"
                    sx={{
                        height: 140,
                        width: 180,
                        color: 'outline.main',
                        backgroundColor: 'surfaceDim.main',
                        m: 1.4,
                        borderRadius: 3,
                    }}
                >
                    <Icon sx={{ height: 120, width: 120 }} />
                </Avatar>
            </CardMedia>
            <CardHeader title={file.name} subheader={file.date} />
        </Card>
    );
};

const ContactFiles = () => {
    return (
        <Box display="flex" flexWrap="wrap" gap={2}>
            {files.map(file => (
                <FileComponent key={file.id} file={file} />
            ))}
        </Box>
    );
};

export default ContactFiles;
